import { render } from "./message-image.vue?vue&type=template&id=1c5814c4&scoped=true&ts=true"
import script from "./message-image.vue?vue&type=script&lang=ts"
export * from "./message-image.vue?vue&type=script&lang=ts"

import "./message-image.vue?vue&type=style&index=0&id=1c5814c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5814c4"]])

export default __exports__